export var PopupVariant;
(function (PopupVariant) {
    PopupVariant["Primary"] = "primary";
    PopupVariant["Secondary"] = "secondary";
    PopupVariant["Success"] = "success";
    PopupVariant["Danger"] = "danger";
    PopupVariant["Warning"] = "warning";
    PopupVariant["Info"] = "info";
    PopupVariant["Light"] = "light";
    PopupVariant["Dark"] = "dark";
})(PopupVariant || (PopupVariant = {}));
export var YesNo;
(function (YesNo) {
    YesNo[YesNo["Yes"] = 0] = "Yes";
    YesNo[YesNo["No"] = 1] = "No";
    YesNo[YesNo["Cancel"] = 2] = "Cancel";
})(YesNo || (YesNo = {}));
